module.exports = __webpack_public_path__ + "fonts/a6f5480.ttf";